export default __webpack_public_path__ + "static/media/rubik-v12-latin-regular.2de78ee5.ttf";